import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Swal from 'sweetalert2';
import CustomTable from '../../helpers/custom-table'
import { catchError } from '../../helpers/catch-error-client'
import DatePicker from "react-datepicker";

import { NavLink } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';



const RecordsObtained = () => {
  const navigate = useNavigate();
  var columns = React.useMemo(
    () => [
      {
        accessorFn: row => row.work_order_id + "_" + row.work_order_no + "_" + row.is_updated,
        id: "work_order_id",
        cell: ({ getValue }) => (
          <a className={(getValue().split("_"))[2] == 1 ? "fw-bold text-shadow text-danger" : ""}
            href={"/client/work-order/" + (getValue().split("_"))[0]}
          >{(getValue().split("_"))[1]}</a>
        ),
        header: () => "ID",
        size: 100,
      },
      {
        accessorFn: row => row.patient_last_name + " " + row.patient_first_name + "__" + row.wo_policy_number,
        id: "patient_policy",
        cell: ({ getValue }) => (
          <span>
            <ul className="table-ul">
              {(getValue().split("__")).map((p, index) => (
                <li key={index}>{p}</li>
              ))}
            </ul>
          </span>
        ),
        header: () => "Patient/Policy#",
        footer: props => props.column.id
      },
      {
        accessorFn: row => row.status == 4 ? "WAITING TO BE INVOICED" :
          (row.status == 5 ? "INVOICE GENERATED" : "PAYMENT(S) RECEIVED"
          ),
        id: "status",
        cell: info => info.getValue(),
        header: () => "Status",
        footer: props => props.column.id
      },
      {
        accessorKey: "copy_date_set_by",
        header: "Copy Date Set By",
        footer: props => props.column.id
      },
      {
        accessorKey: "facility_name",
        header: "FACILITY",
        footer: props => props.column.id
      },
      {
        accessorFn: row => <>
          <a onClick={() => copyWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link m-0 p-0 me-2">Copy</a>
        </>,
        id: "actions",
        cell: info => info.getValue(),
        header: () => "ACTIONS",
        footer: props => props.column.id,
        enableColumnFilter: false,
        enableSorting: false,
      }


    ],
    []
  )


  const [data, setData] = React.useState(null);
  const [isBtn,setIsBtn] = React.useState(false);
 
  const [woSearch, setWoSearch] = React.useState(null);

  const getWorkOrders = async () => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-records-obtained", {}, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          setData(response?.data?.work_orders);

         


        } else {

          Swal.fire({ icon: "error", title: "Records Obtained Work Order Failed to Load" });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });

  }


  const getWorkOrdersFiltered = async () => {

    setIsBtn(true);
    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-records-obtained",
      woSearch,
      {
        withCredentials: true
      })
      .then(function (response) {

        if (response?.data?.status) {

          setData(response?.data?.work_orders);


        } else {

          Swal.fire({ icon: "error", title: "Records Obtained Work Order Failed to Load" });

        }
        setIsBtn(false);

      })
      .catch(function (error) {

        setIsBtn(false);
        catchError(error, navigate)

      });

  }
  




  const copyWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/copy-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();
          Swal.fire({ icon: "success", title: "Work order copied successfully. " });

        } else {

          Swal.fire({ icon: "error", title: "Unable to copy work order " });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });


  }



  useEffect(() => {

    getWorkOrders();

  }, []);

  return (
    <>

   

<div className="row py-2 start-0 bg-light">

<div className="col-md-12 col-sm-12 mx-auto text-center">
  <div className="container-fluid z-2  ">

    <span className="btn btn-warning rounded-0 me-1">
      <NavLink className="nav-link" smooth to="/client/work-orders-active">
        ACTIVE
      </NavLink>
    </span>
    <span className="btn btn-success rounded-0  me-1 ">
      <NavLink className="nav-link" smooth to="/client/work-orders-records-obtained">
        RECORDS OBTAINED
      </NavLink>
    </span>

    <span className="btn btn-warning rounded-0  me-1 ">
      <NavLink className="nav-link" smooth to="/client/work-orders-closed">
        CLOSED
      </NavLink>
    </span>

    <span className="btn btn-warning rounded-0  ">
      <NavLink className="nav-link" smooth to="/client/work-orders-incomplete">
        INCOMPLETE
      </NavLink>
    </span>
  </div>
</div>
</div>


<div className="row py-4 start-0  mx-auto ">

<div className="col-md-6 col-sm-12  ">
  <h3 className="text-dark my-0">RECORDS OBTAINED WORK ORDERS</h3>
</div>

<div className="col-md-6 col-sm-12 ps-3 text-end">

  <span className="btn btn-primary rounded-0 me-1">
    <NavLink className="nav-link" smooth to="/client/work-orders-new">
      NEW
    </NavLink>
  </span>
  <span className="btn btn-danger rounded-0  me-1 ">
    <NavLink className="nav-link" smooth to="/client/work-orders-search">
      SEARCH
    </NavLink>
  </span>

</div>

</div>




      <div className="card card-form card-primary mb-3">
        <div className="card-body">
          <form className="form-horizontal form-thick mb-2"  >

            <div className="row px-5 gx-5">

              <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                <label htmlFor="case_manager">Case Manager</label>
                <input name="case_manager" className="form-control" type="text"
                  value={woSearch?.case_manager}
                  onChange={(e) =>
                    setWoSearch({ ...woSearch, case_manager: e.target.value })
                  }
                />
              </div>
              <div className="col-xl-2  col-lg-2 col-sm-12 my-1">
                <label htmlFor="facility">Facility</label>
                <input name="facility" className="form-control" type="text"
                  value={woSearch?.facility}
                  onChange={(e) =>
                    setWoSearch({ ...woSearch, facility: e.target.value })
                  }


                />



              </div>



              <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                <label htmlFor="invoice_date_range">Invoice From</label>

                <DatePicker name="from" id="from" type="text"
                  className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  selectsStart
                  isClearable={true}
                  selected={woSearch?.from}
                  onChange={(e) => {
                    
                      var dt = new Date(e);

                      const year = dt.getFullYear();
                      const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                      const day = dt.getDate().toString().padStart(2, "0");
    
                      const formatted_date = month + '/' + day + '/' + year
                      setWoSearch({ ...woSearch, from: formatted_date })
                      
                    }
                    
                  
                  }
                />
              </div>
              <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                <label htmlFor="invoice_date_range">Invoice To</label>

                <DatePicker name="to" id="to" type="text"
                  className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  selectsEnd
                  isClearable={true}
                  selected={woSearch?.to}
                  onChange={(e) => {
                    
                    var dt = new Date(e);

                    const year = dt.getFullYear();
                    const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                    const day = dt.getDate().toString().padStart(2, "0");
  
                    const formatted_date = month + '/' + day + '/' + year
                    setWoSearch({ ...woSearch, to: formatted_date })
                    
                  }
                  }
                />
              </div>



            </div>


          </form>

        </div>

        <div className="card-footer">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
              <button onClick={() => getWorkOrdersFiltered()} className="btn btn-success mx-1" type="button" disabled={isBtn?true:false} >{isBtn?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"FILTER"} </button>
          
            </div>

          </div>
        </div>
      </div>


      {data &&

<div className="card border-4 border-dark rounded-1 card-success mb-4" >

<div className="card-body p-0" >

            <CustomTable columns={columns} data={data} />

          </div>
        </div>


      }
    </>
  );
};

export default RecordsObtained;